import dayjs from "dayjs";
import type { Dayjs } from "dayjs";

// Same rules as the backend (Backend/api/customers/validation.py)
const MAX_AGE_YEARS = 100;

/** Birth date can be picked: not in the future, not older than 100 years, child at least minAge years old. */
export const isPlausibleBirthDate = (date: Dayjs, minAge = 0): boolean =>
  !date.isAfter(dayjs().subtract(minAge, "year"), "day") &&
  !date.isBefore(dayjs().subtract(MAX_AGE_YEARS, "year"), "day");

/** Birth date pickers open on a plausible year instead of the current month. */
export const birthDatePickerDefault = () => dayjs().subtract(8, "year");
